import React from 'react'
import PropTypes from 'prop-types'

import Wave from 'components/shared/Wave/Wave'

import './CollectionHeader.scss'

export const CollectionHeader = ({
  slug,
  subtitle,
  title,
  theme,
  imageLeft = false,
}) => {
  const headerImg = slug || 'default'

  return (
    <header className="c-collection-header">
      <div
        className={`c-collection-header__wrapper  ${
          imageLeft ? 'c-collection-header__wrapper--left' : ''
        }`}
      >
        <div className="c-collection-header__text">
          <h1 className="c-collection-header__title">{title}</h1>
          <h2
            className="c-collection-header__subtitle"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        </div>
        <div
          className={`c-collection-header__image  ${
            imageLeft ? 'c-collection-header__image--left' : ''
          } c-collection-header__image--${headerImg} `}
        ></div>
      </div>
      <Wave imageLeft={false} theme={theme || 'cyan'} />
    </header>
  )
}

CollectionHeader.propTypes = {
  imageLeft: PropTypes.bool,
  slug: PropTypes.string,
  theme: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default CollectionHeader
